<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<mat-sidenav-container class="appcontent-container" autosize>
  <mat-sidenav class="appbarmenu-container" #sidenav mode="side" [(opened)]="isSidebarOpen">
    @if (permissions) {
    <mat-toolbar class="sidenav-header" title="Exit Administration" [routerLink]="['/']">
      <a class="nolink" [routerLink]="['/']">
        <div class="cssLayoutRowStartCenter">
          <mat-icon class="icon-35px alloy-icon" svgIcon="ic_crucible_alloy"></mat-icon>
          <h2 class="icon-text">Administration</h2>
        </div>
      </a>
    </mat-toolbar>
    <mat-list class="appitems-container">
      <mat-list-item class="showhand" (click)="adminGotoEventTemplates()"
        [ngClass]="getSelectedClass(eventTemplatesText)">
        <mat-icon matListItemIcon class="mat-list-item-icon" fontIcon="mdi-clipboard"></mat-icon>
        Event Templates
        <button mat-icon-button class="pull-right">
          <mat-icon fontIcon="mdi-menu-right"></mat-icon>
        </button>
      </mat-list-item>
      <mat-list-item class="showhand" (click)="adminGotoEvents()" [ngClass]="getSelectedClass(eventsText)">
        <mat-icon matListItemIcon class="mat-list-item-icon" fontIcon="mdi-clipboard-play"></mat-icon>
        Events
        <button mat-icon-button class="pull-right">
          <mat-icon fontIcon="mdi-menu-right"></mat-icon>
        </button>
      </mat-list-item>
      @if (permissions.includes(SystemPermission.ViewUsers)) {
      <mat-list-item class="showhand" (click)="adminGotoUsers()" [ngClass]="getSelectedClass(usersText)">
        <mat-icon matListItemIcon class="mat-list-item-icon" fontIcon="mdi-account-multiple"></mat-icon>
        Users
        <button mat-icon-button class="pull-right">
          <mat-icon fontIcon="mdi-menu-right"></mat-icon>
        </button>
      </mat-list-item>
      }
      @if (permissions.includes(SystemPermission.ViewRoles)) {
      <mat-list-item class="showhand" (click)="adminGotoRoles()" [ngClass]="getSelectedClass(rolesText)">
        <mat-icon matListItemIcon class="mat-list-item-icon" fontIcon="mdi-lock"></mat-icon>
        Roles
        <button mat-icon-button class="pull-right">
          <mat-icon fontIcon="mdi-menu-right"></mat-icon>
        </button>
      </mat-list-item>
      }
      @if (permissions.includes(SystemPermission.ViewGroups)) {
      <mat-list-item class="showhand" (click)="adminGotoGroups()" [ngClass]="getSelectedClass(groupsText)">
        <mat-icon matListItemIcon class="mat-list-item-icon" fontIcon="mdi-account-group"></mat-icon>
        Groups
        <button mat-icon-button class="pull-right">
          <mat-icon fontIcon="mdi-menu-right"></mat-icon>
        </button>
      </mat-list-item>
      }
    </mat-list>
    }
    @if (!hideTopbar) {
    <img class="crucible-logo" [src]="
        (theme$ | async) === 'light-theme'
          ? 'assets/img/crucible-logo-light.png'
          : 'assets/img/crucible-logo-dark.png'
      " />
    }
  </mat-sidenav>
  <mat-sidenav-content>
    @if (!hideTopbar) {
    <app-topbar [title]="showStatus" [topbarView]="TopbarView.ALLOY_ADMIN" [sidenav]="sidenav"
      (sidenavToggle)="sidenav.toggle()"></app-topbar>
    }
    @if (permissions) {
    <span>
      @if (showStatus === eventTemplatesText) {
      <app-event-templates></app-event-templates>
      }
      @if (showStatus === eventsText) {
      <app-events [refresh]="shouldUpdateEvents"></app-events>
      }
      @if (
      showStatus === rolesText &&
      permissions.includes(SystemPermission.ViewRoles)
      ) {
      <app-admin-roles></app-admin-roles>
      }
      @if (
      showStatus === groupsText &&
      permissions.includes(SystemPermission.ViewGroups)
      ) {
      <app-admin-groups></app-admin-groups>
      }
      @if (
      showStatus === usersText &&
      permissions.includes(SystemPermission.ViewUsers)
      ) {
      <app-admin-users></app-admin-users>
      }
    </span>
    }
  </mat-sidenav-content>
</mat-sidenav-container>
